import { Alert, Button, Form, Input, Space, notification } from "antd"
import { useEffect } from "react"
import { PasswordRequirements, PASSWORD_REGEX } from "../authentication/PasswordRequirements"
import { useUpdatePassword } from "./accountQueries"

export type Props = {
  email: string
}

const UpdatePassword = ({ email }: Props) => {
  const [passwordResetForm] = Form.useForm()
  const password = Form.useWatch('newPassword', passwordResetForm)

  const updatePasswordMutation = useUpdatePassword()

  const handleSubmit = (values: any) => {
    const request = {
      email,
      oldPassword: values.currentPassword,
      newPassword: values.newPassword,
      confirmNewPassword: values.confirmNewPassword
    }

    updatePasswordMutation.mutate(request)
  }

  useEffect(() => {
    if (updatePasswordMutation.isSuccess) {
      passwordResetForm.resetFields()
      notification.success({ message: 'Password updated successfully' })
    }
  }, [updatePasswordMutation.isSuccess])

  return <Space align="start" size="large">
    <Form form={passwordResetForm} layout='vertical' style={{ width: 400 }} onFinish={handleSubmit}>
      <Form.Item
        name="currentPassword"
        rules={[
          { required: true, message: 'Current password is required' },
        ]}
      >
        <Input.Password placeholder="Current password" />
      </Form.Item>
      <Form.Item
        name="newPassword"
        rules={[
          { required: true, message: 'New password is required' },
          { pattern: PASSWORD_REGEX, message: 'Password does not meet the requirements' }
        ]}>
        <Input.Password placeholder="New password" />
      </Form.Item>
      <Form.Item
        name="confirmNewPassword"
        rules={[
          {
            validator: (_, value) => {
              if (value !== password) {
                return Promise.reject('Passwords must match')
              }
              return Promise.resolve()
            }
          }
        ]}
      >
        <Input.Password placeholder="Confirm new password" />
      </Form.Item>
      <Form.Item hidden={!updatePasswordMutation.isError}>
        <Alert message={(updatePasswordMutation.error as Error)?.message} type="error" />
      </Form.Item>
      <Form.Item>
        <Button htmlType="submit" type="primary">Update password</Button>
      </Form.Item>
    </Form>
    {password &&
      <PasswordRequirements password={password} />
    }
  </Space>
}

export default UpdatePassword
